import { render, staticRenderFns } from "./ModalRenameContact.vue?vue&type=template&id=0d16e229&scoped=true"
import script from "./ModalRenameContact.vue?vue&type=script&lang=js"
export * from "./ModalRenameContact.vue?vue&type=script&lang=js"
import style0 from "./ModalRenameContact.vue?vue&type=style&index=0&id=0d16e229&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d16e229",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d16e229')) {
      api.createRecord('0d16e229', component.options)
    } else {
      api.reload('0d16e229', component.options)
    }
    module.hot.accept("./ModalRenameContact.vue?vue&type=template&id=0d16e229&scoped=true", function () {
      api.rerender('0d16e229', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/personalization/ModalRenameContact.vue"
export default component.exports